/* eslint-disable react/display-name */
import React, { useCallback } from 'react';
import { useSelector, useDispatch } from 'react-redux';
import PropTypes from 'prop-types';
import { fetchTooltipData } from '@actions/tooltips-actions';
import ActivityLogTooltip from '@components/activity-logs/tooltips';
import { getAgencyIcon } from '@utils/icon-utils';
import './tooltip.scss';

const UserTooltip = ({ children, id, text }) => {
  const dispatch = useDispatch();
  const data = useSelector(state => state.tooltips.log_user[id]);
  const error = useSelector(state => state.tooltips.error.log_user?.[id]);

  const handleFetch = useCallback(() => {
    dispatch(fetchTooltipData('log_user', null, id));
  }, [dispatch, id]);

  const renderContent = useCallback(() => (
    <div styleName="body-content">
      {data?.agency_type && (
        <div styleName="body-row body-item">
          <img
            alt=""
            src={getAgencyIcon({ id: data.agency_type })}
            styleName="icon"
          />
          {data.agency_name}
        </div>
      )}
      <div styleName="body-title">
        {data?.name}
        {data && !data.is_active && (
          <div styleName="inactive">
            (Inactive)
          </div>
        )}
      </div>
      {(data?.email || data?.phone) && <div styleName="body-padding" />}
      {(data?.email || data?.phone) && (
        <div styleName="body-row">
          {data.email}
          {data.phone && <div styleName="bull">&bull;</div>}
          {data.phone}
        </div>
      )}
    </div>
  ), [data]);

  return (
    <ActivityLogTooltip
      data={data}
      error={error}
      onFetch={handleFetch}
      renderContent={renderContent}
      dataType="user"
    >
      {children || text}
    </ActivityLogTooltip>
  );
};

UserTooltip.propTypes = {
  children: PropTypes.node,
  id: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
  text: PropTypes.string
};

export default UserTooltip;
